import React from "react";

const EmpInfoCard = ({empName,department,designation,email}) => {
    return (
        <div className="card mb-2">
            <div className="">
                <div className="row divEmpInfo">
                    <div className="col-md-3">
                        <b>Name: </b>{empName}
                    </div>
                    <div className="col-md-3">
                        <b>Department: </b>{department}
                    </div>
                    <div className="col-md-3">
                       <b> Designation:</b> {designation}
                    </div>
                    <div className="col-md-3">
                       <b> Email:</b> {email}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default EmpInfoCard